module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-non-bodymatter element-type-none element-with-heading",
    attrs: {
      "id": "book-description"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "book-description-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Book Description")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "book-description-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("Together in one volume, two frighteningly hilarious Dan Shamble, Zombie P.I. adventures!")])])]), _vm._v(" "), _c('h3', {
    staticClass: "subhead"
  }, [_vm._v("Unnatural Acts")]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-chapter first-full-width first-after-subhead"
  }, [_vm._v("In the Unnatural Quarter, golems slave away in sweatshops, necromancers sell black-market trinkets to tourists, and the dead rise up—to work the night shift. But zombie detective Dan Shamble is no ordinary working stiff. When a local senator and his goons picket a ghostly production of Shakespeare in the Dark—condemning the troupe’s “unnatural” lifestyles—Dan smells something rotten. And if something smells rotten to a zombie, you’re in serious trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Before his way of life, er, death, is destroyed, Dan wants answers. Along the way he needs to provide security for a mummified madame, defend a mixed-race couple (he’s a vampire, she’s a werewolf) from housing discrimination, and save his favorite watering hole, the Goblin Tavern, from drying up. Throw in a hairy hitman, a necro-maniac, and a bank robber who walks through walls, and Dan Shamble’s plate is full. Maybe this time, the zombie detective has bitten off more than he can chew.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead"
  }, [_vm._v("Hair Raising")]), _vm._v(" "), _c('p', {
    staticClass: "first first-after-subhead"
  }, [_vm._v("The fur really flies when a serial scalper stalks the supernatural citizens of the Unnatural Quarter, targeting werewolves—and what’s sadder than a bald lycanthrope? Dan Shamble, Zombie P.I., is on the case, trying to stop an all-out gang war between full-time and full-moon werewolves. As he combs through the tangled clues to hunt down the bald facts, things get hairy fast.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Shamble lurches through a loony landscape of voodoo tattoo artists, illicit cockatrice fights, body builders assembling make-your-own human kits, and perhaps scariest of all, crazed fans in town for the Worldwide Horror Convention. Yet the reign of hair-raising terror grows longer. If Shamble can’t snip this off at the roots, the whole world could end up howling mad.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-255c618d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bookdescription.vue
// module id = 69
// module chunks = 0